export default "__VITE_ASSET__B7Mqs5Mm__"